import type { MapMarkerCircleStyle } from '@gpx-spa/geo-domain';
import { V2_CURRENT_POSITION_MARKER_STYLE } from '@/map/operational/v2-current-positions-markers';

/** Single-device cluster: same live-dot as today (no count label). */
export const CONVOY_SINGLE_MARKER_STYLE: MapMarkerCircleStyle = {
  ...V2_CURRENT_POSITION_MARKER_STYLE,
};

/** Multi-device cluster: live-dot look with count digit. */
export const CONVOY_GROUP_MARKER_STYLE: MapMarkerCircleStyle = {
  ...V2_CURRENT_POSITION_MARKER_STYLE,
  sizePx: 32,
  fontSizePx: 14,
  textColor: '#ffffff',
};

export function convoyMarkerStyleForCount(count: number): MapMarkerCircleStyle {
  if (count <= 1) return CONVOY_SINGLE_MARKER_STYLE;
  return {
    ...CONVOY_GROUP_MARKER_STYLE,
    label: String(count),
  };
}
